{
  "common": {
    "cancel": "Cancel",
    "close": "Close",
    "delete": "Delete",
    "edit": "Edit",
    "save": "Save",
    "show": "Show",
    "hide": "Hide",
    "search": "Search…",
    "clearSearch": "Close search",
    "noMatch": "Nothing found",
    "retry": "Try again"
  },
  "page": {
    "preview": "Preview",
    "save": "Save",
    "saveHint": "Save (Ctrl+S)",
    "loading": "Loading…",
    "loadError": "Could not load the dashboard"
  },
  "save": {
    "success": "Saved",
    "successHint": "Changes are visible to all users",
    "error": "Could not save",
    "unknownSection": "The section linked to a marker was not found",
    "conflictTitle": "The page was changed by another user",
    "conflictTextBy": "{{name}} saved a newer version at {{time}}. You can reload the latest version or overwrite it with your changes.",
    "conflictText": "A newer version of the page was saved at {{time}}. You can reload the latest version or overwrite it with your changes.",
    "reload": "Reload",
    "overwrite": "Overwrite",
    "reloaded": "Latest version loaded",
    "linksDropped": "Removed links to a deleted section: {{names}}",
    "unknownSectionHint": "Pick the section again in the marker settings: {{names}}"
  },
  "unsaved": {
    "title": "You have unsaved changes. Leave?",
    "text": "If you leave without saving, your changes will be lost.",
    "save": "Save",
    "discard": "Leave without saving",
    "stay": "Stay on the page"
  },
  "preview": {
    "back": "Back to editing",
    "label": "{{title}} — preview"
  },
  "types": {
    "background": "Background",
    "clock": "Clock",
    "date": "Date",
    "indicator": "Indicator",
    "title": "Title",
    "marker": "Marker",
    "image": "Image",
    "gif": "GIF",
    "video": "Video",
    "sectionGrid": "Sections"
  },
  "popoverTitles": {
    "background": "Background",
    "clock": "Clock",
    "date": "Date",
    "indicator": "Indicator",
    "title": "Title",
    "marker": "Marker",
    "image": "Image",
    "gif": "GIF",
    "video": "Video"
  },
  "rail": {
    "label": "Widgets",
    "hint": "{{name}} — click to set up, or drag onto the canvas",
    "backgroundHint": "Background — the dashboard backdrop"
  },
  "canvas": {
    "label": "Dashboard canvas",
    "roledescription": "editing area",
    "emptyTitle": "No widgets yet",
    "emptyText": "Pick a widget in the “Widgets” rail on the right and add it to the canvas",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "fit": "Fit to screen",
    "zoom100": "Show at 100%",
    "zoomLevel": "Zoom {{value}}%",
    "locked": "Locked"
  },
  "menu": {
    "duplicate": "Duplicate",
    "forward": "Bring forward",
    "backward": "Send backward",
    "paste": "Paste"
  },
  "elements": {
    "title": "Elements",
    "search": "Search elements",
    "add": "Add element",
    "empty": "No elements",
    "emptyHint": "No elements yet.",
    "lock": "Lock",
    "unlock": "Unlock",
    "rename": "Rename",
    "reorderHint": "Drag or press Alt + ↑ / ↓ to change the order. Double-click to rename.",
    "deleted": "“{{name}}” deleted",
    "undo": "Undo"
  },
  "sections": {
    "title": "Sections",
    "search": "Search sections",
    "add": "Add section",
    "count": "{{count}} indicators",
    "empty": "No sections",
    "emptyHint": "No sections yet. Press “Add section” to create one.",
    "loadError": "Could not load the sections",
    "saveError": "Could not save the change",
    "deleteTitle": "Delete section",
    "deleteText": "Section “{{name}}”, its folders, drawings and indicators will be deleted.",
    "deleted": "Section deleted",
    "deleteError": "Could not delete the section",
    "reorderHint": "Drag or press Alt + ↑ / ↓ to change the card order. Click the name to open the section settings."
  },
  "sectionModal": {
    "createTitle": "New section",
    "createSubtitle": "Add a monitoring page",
    "editTitle": "Edit section",
    "editSubtitle": "Monitoring page settings",
    "name": "Section name",
    "namePlaceholder": "e.g. Clinometer",
    "nameRequired": "Enter the section name",
    "nameTaken": "A section with this name already exists",
    "icon": "Icon",
    "uploadIcon": "Upload icon",
    "uploadIconHint": "SVG or PNG, up to 256 KB, at least 48×48 px",
    "iconType": "The icon must be an SVG or PNG",
    "iconTooBig": "The icon must not exceed 256 KB",
    "iconTooSmall": "The icon must be at least 48×48 px",
    "cardMode": "What the card shows",
    "modeFull": "Icon, name, count",
    "modeName": "Name only",
    "countSource": "Count source",
    "countAuto": "Automatic",
    "countManual": "Manual",
    "manualCount": "Enter the count manually",
    "manualCountHint": "pcs (manually set value)",
    "countInvalid": "Enter a whole number from 0 to 999 999",
    "create": "Add section",
    "created": "Section added",
    "updated": "Section saved",
    "limit": "The section limit (50) has been reached",
    "saveError": "Could not save the section"
  },
  "popover": {
    "close": "Close",
    "drag": "Move the panel",
    "add": "Add",
    "deleteWidget": "Delete widget",
    "scale": "Size",
    "decrease": "decrease",
    "increase": "increase"
  },
  "empty": {
    "clock": {
      "title": "Add clock",
      "text": "Add a clock widget"
    },
    "date": {
      "title": "Add date",
      "text": "Add a date widget"
    },
    "indicator": {
      "title": "Add indicator",
      "text": "Add a indicator widget"
    },
    "title": {
      "title": "Add title",
      "text": "Add a title widget"
    },
    "marker": {
      "title": "Add marker",
      "text": "Add a marker widget"
    },
    "image": {
      "title": "Add image",
      "text": "Add a image widget"
    },
    "gif": {
      "title": "Add GIF",
      "text": "Add a GIF widget"
    },
    "video": {
      "title": "Add video",
      "text": "Add a video widget"
    }
  },
  "clock": {
    "seconds": "Show seconds"
  },
  "date": {
    "format": "Format"
  },
  "indicator": {
    "icon": "Icon",
    "source": "Value source",
    "manual": "Manual",
    "pick": "Select",
    "name": "Name",
    "value": "Value",
    "unit": "Unit",
    "sensor": "Device",
    "sensorPlaceholder": "Select a device",
    "sensorSearch": "Search devices or indicators",
    "sensorsLoading": "Loading devices…",
    "noSensors": "No devices found"
  },
  "title": {
    "title": "Title",
    "titlePlaceholder": "Write a title",
    "titleSize": "Title size",
    "subtitle": "Subtitle",
    "subtitlePlaceholder": "Write the site name",
    "subtitleSize": "Subtitle size",
    "accentBar": "Show the left bar",
    "logo": "Show the logo",
    "logoHint": "Before the title in the viewer"
  },
  "marker": {
    "name": "Name",
    "link": "Link to a section",
    "noLink": "None",
    "side": "Label side",
    "sideAuto": "Auto",
    "sideLeft": "Left",
    "sideRight": "Right"
  },
  "media": {
    "upload": {
      "image": "Upload image",
      "gif": "Upload GIF",
      "video": "Upload video"
    },
    "aspect": "Aspect ratio",
    "width": "Width",
    "zoom": "Zoom",
    "autoplay": "Autoplay (muted)",
    "loop": "Loop",
    "replace": "Replace",
    "remove": "Remove file",
    "uploading": "Uploading…",
    "uploadError": "Could not upload the file",
    "tooLarge": "The file must not exceed {{max}}",
    "badType": "Files of this type are not accepted",
    "noRight": "You are not allowed to upload files",
    "meta": "{{w}} × {{h}} px · {{size}}"
  },
  "background": {
    "emptyTitle": "Add background",
    "emptyText": "Add a background widget",
    "upload": "Upload file",
    "opacity": "Opacity",
    "scale": "Zoom",
    "remove": "Remove background",
    "removeTitle": "Remove background",
    "removeText": "The background file will be removed from the dashboard. Until you save, Ctrl+Z brings it back.",
    "type": "Background type",
    "typeImage": "Image",
    "typeVideo": "Video",
    "typeGif": "GIF"
  }
}
